import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Embarque } from '../types'

export default function Embarques() {
  return (
    <PaginaOperaciones<Embarque>
      titulo="Embarques"
      recurso="embarques"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'packingFolio', titulo: 'Packing' },
        { campo: 'pedidoFolio', titulo: 'Pedido' },
        { campo: 'clienteNombre', titulo: 'Cliente' },
        { campo: 'transportistaNombre', titulo: 'Transportista' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fecha', titulo: 'Fecha', render: (e) => e.fecha?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Confirmar',
          endpoint: (e) => `embarques/${e.id}/confirmar`,
          body: (e) => ({ id: e.id, estado: 'Confirmado' })
        },
        {
          label: 'Autorizar',
          endpoint: (e) => `embarques/${e.id}/autorizar`,
          body: (e) => ({ id: e.id, estado: 'Autorizado' }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
